export default "__VITE_ASSET__c1e8664f__"